export default __webpack_public_path__ + "media/images/images/backgrounds/bg-6-b0e8fa3f8ec3fe4fec3d8cd5de2e35d9.jpg";